import { render, staticRenderFns } from "./TableType8.vue?vue&type=template&id=64fe27e9&"
import script from "./TableType8.vue?vue&type=script&lang=js&"
export * from "./TableType8.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports